import React from "react";

import "./Footer.css";

const Footer = () => {
    return (
        <div className="col-md-12">
            <div className="footer_conatiner">
                <small className="footer_paragraph">Copyright © 2025 Avance Revalida.</small>
            </div>
        </div>
    );
};

export default Footer;